import withRouter from '@utils/wrappers/WithRouter';
import { Button, Modal, Grid, Icon } from '@ts/storybook';
import { height } from '@mui/system';
const Fab = require('@mui/material/Fab').default;

const _ = require('lodash');
const moment = require('moment');
const PropTypes = require('prop-types');
const React = require('react');
const createReactClass = require('create-react-class');
const Mui = require('@mui/material');
const act = require('@flux/actions/actView');

const k = require('@gral/constants');
const Mixin = require('@utils/mixin/mixin');
const helpers = require('@utils/helpers');
const Misc = require('@components/Misc');
const App = require('@gral/app');
const Error403 = require('@components/Errors/403').default;
const NeedsManager = require('@utils/NeedsManager').default;
const modelNameEntityLidMap = require('@gral/modelNameEntityLidMap').default;

const { withTranslation } = require('react-i18next');

class EditPage extends React.Component {
  static displayName = '320-EditPageContainer';

  // This is just to make sure that the inner component gets unmounted when
  // going from edit to view or vice versa
  state = { backSteps: 1 };

  addBackStep = () => this.setState({ backSteps: this.state.backSteps + 1 });

  render() {
    return (
      <EditPageOld
        {...Object.assign(
          {
            key: this.props.transferPropsRoute.location.key,
          },
          this.props,
          {
            backSteps: this.state.backSteps,
            addBackStep: this.addBackStep,
          }
        )}
      />
    );
  }

  componentWillUnmount() {
    return act.deleteResource('selectedTab');
  }
}

const EditPageOld = createReactClass({
  displayName: 'EditPageOld',
  mixins: [Mixin.Base, Mixin.Needs],

  propTypes: {
    app: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    modelName: PropTypes.string.isRequired,
    collectionDataPath: PropTypes.string,
    apiBaseUrl: PropTypes.string,
    defaultAttrs: PropTypes.object,
    needs: PropTypes.array,
    invalidates: PropTypes.array,
    fnInitState: PropTypes.func,
    fnPrepareSave: PropTypes.func,
    FormComponent: PropTypes.func.isRequired,
    fTopButtons: PropTypes.bool,
    fOnCancelGoBack: PropTypes.bool,
    fOnSaveGoBack: PropTypes.bool,
    fNewButton: PropTypes.bool,
    fDeleteButton: PropTypes.bool,
    fSaveConfirmation: PropTypes.bool,
    entity: PropTypes.string,
  },

  getDefaultProps() {
    return {
      defaultAttrs: {},
      apiBaseUrl: '/api',
      needs: [],
      invalidates: [],
      fnInitState(state) {
        return {};
      },
      fnPrepareSave(attrs) {
        return attrs;
      },
      fTopButtons: false,
      fOnCancelGoBack: false,
      fOnSaveGoBack: false,
      fNewButton: true,
      fDeleteButton: true,
      fSaveConfirmation: false,
      fAskPwdOnSave: false,
      operations: {
        new: 'create',
        edit: 'update',
      },
      reloadSettings: false,
    };
  },
  getInitialState() {
    return _.extend(this.props.defaultAttrs, {
      _fInitialised: false,
      _fModalDelete: false,
      _fModalSave: false,
      _fModalPwd: false,
    });
  },

  //#region Component Life-Cycle
  componentWillUnmount() {
    act.deleteResource(this._dataPath);
    return act.deleteResource('confirmPassword');
  },
  //   act.markAsStale @_dataPath
  //   act.markAsStale "users"
  UNSAFE_componentWillMount() {
    const { app, data, needs, modelName, apiBaseUrl } = this.props;
    this._fSaving = false;
    this._fDeleting = false;
    this._fAutoFocused = false;
    this._fSaveAllowed = true;
    this._saveModalTitle = '';
    this._fDisableSaveConfirmation = false;
    // Determine current mode: `new`, `view` or `edit`
    this._route = this.props.transferPropsRoute;
    const { id } = this._route;
    const needsManager = new NeedsManager(data, needs);

    if (/View$/.test(id)) {
      this._mode = 'view';
    } else if (/Edit$/.test(id)) {
      this._mode = 'edit';
    } else if (/Copy$/.test(id)) {
      this._mode = 'copy';
    } else {
      this._mode = 'new';
    }

    this.checkPermission();

    // Datapath for model being created/viewed/edited, and
    // other resources we need for the page
    if (this._mode === 'new' || this._mode === 'copy') {
      this._dataPath = `edit${_.capitalize(modelName)}`;
    } else {
      const { id } = this._route.params;
      this._dataPath = `edit${_.capitalize(modelName)}_${id}`;
      const rsrcUrl = `${apiBaseUrl}/${modelName}/${id}`;
      needsManager.iNeed({
        url: rsrcUrl,
        dataPath: this._dataPath,
      });
    }
    needsManager.iNeed({ url: '/api/users', dataPath: 'users' });
    needsManager.fetchNeeds();

    // Initialise state (based on the store state)
    this._rsrc = data.get(this._dataPath);
    return this._initialiseState();
  },
  // If not done during the initial mounting, initialise state now
  componentWillReceiveProps(nextProps) {
    this._rsrc = nextProps.data.get(this._dataPath);
    const needsManager = new NeedsManager(nextProps.data);

    this.props.needs.forEach(need => {
      const rsrc = nextProps.data.get(need.dataPath);

      if (rsrc == null) {
        return needsManager.iNeed(need);
      }
    });
    needsManager.fetchNeeds();
    this._initialiseState();
    // handle confirm password response
    if (
      this.props.data.getIn(['confirmPassword', 'state']) === 'SYNCING' &&
      nextProps.data.getIn(['confirmPassword', 'state']) === 'IDLE'
    ) {
      const result = nextProps.data.getIn(['confirmPassword', 'data', 'isValid']);
      if (result === true) {
        return this._handleConfirmSave();
      }
      return act.notify({
        msg: this.props.t('Wrong password'),
        timeOut: '2000',
      });
    }
  },

  componentDidUpdate() {
    if (this._fSaving || this._fDeleting) {
      if (this._rsrc == null) {
        return;
      }
      if (this._rsrc.get('state') === k.rsrcStates.IDLE) {
        if (this._fSaving) {
          this._fSaving = false;
          if (!helpers.hasErrors(this._rsrc)) {
            this._processInvalidates();
            if (this.props.fOnSaveGoBack) {
              window.history.back();
            } else {
              this._changeMode('view');
            }
          }
        }
        if (this._fDeleting) {
          if (!helpers.hasErrors(this._rsrc)) {
            this._fDeleting = false;
            this._processInvalidates();
            return setTimeout(() => window.history.back(), 0);
          }
          return this._changeMode('view');
        }
      }
    }
  },
  //#endregion

  //#region HandleChanges
  _changeAttrValue(attr) {
    return value => this._changeAttr(attr, value);
  },
  _changeAttr(attr, value) {
    // state = {}
    // state[attr] = value
    // added nested attributes support, needed for json attributes with many editing components
    const { state } = this;
    _.set(state, attr, value);
    return this.setState(state);
  },

  _setfSaveAllowed(val) {
    this._fSaveAllowed = val;
    if (this.state.fSaveAllowed !== val) {
      return this._changeAttr('fSaveAllowed', val);
    }
  },

  _handleClickDone() {
    return window.history.go(this.props.backSteps * -1);
  },
  _handleClickNew() {
    this.props.addBackStep();
    return this.props.navigate(`/${this.props.modelName}/new`);
  }, // , {cleanDatapath:false}
  _handleClickCancel() {
    if (this._mode === 'edit' && !this.props.fOnCancelGoBack) {
      return this._changeMode('view');
    }
    // 'new'

    //return this.props.navigate(-1);
    return window.history.back();
  },
  _handleClickEdit() {
    return this._changeMode('edit');
  },

  _handleClickSave() {
    if (this.props.fSaveConfirmation && !this._fDisableSaveConfirmation) {
      return this.setState({ _fModalSave: true });
    } else if (this.props.fAskPwdOnSave) {
      return this.setState({ _fModalPwd: true });
    }
    return this._handleConfirmSave();
  },

  _handleConfirmSave() {
    if (this.state._fModalSave) {
      this.setState({ _fModalSave: false });
    }
    if (this.state._fModalPwd) {
      this.setState({ _fModalPwd: false });
    }
    const { operations, apiBaseUrl, modelName, reloadSettings } = this.props;
    const attrs = this._getAttrsFromState();
    const op = operations[this._mode];
    const urlBase = `${apiBaseUrl}/${modelName}`;
    const urlExt = this._mode === 'new' ? 'new' : `${this.state.id}`;
    const url = `${urlBase}/${urlExt}`;

    this._fSaving = true;
    act[op]({
      url,
      dataPath: this._dataPath,
      attrs,
      reloadSettings: reloadSettings,
    });

    this.props.navigate(-1);
  },

  _handleClickDelete() {
    return this.setState({ _fModalDelete: true });
  },
  _handleConfirmDelete() {
    const { modelName, apiBaseUrl } = this.props;
    const url = `${apiBaseUrl}/${modelName}/${this.state.id}`;
    this._fDeleting = true;
    act.update({ url, dataPath: this._dataPath, attrs: { isAlive: false } });
    return this.setState({ _fModalDelete: false });
  },
  //#endregion

  //#region Functions

  // Initialise state (based on the store state):
  // - For `new`: it will be initialised at the first try,
  //   either as an empty object (just defaults) or merging
  //   the store state (a data table may have put there some attributes
  //   if the user selected a row before clicking on New)
  // - For `view`, `edit`: it will be initialised as soon as the
  //   record is fetched from the server
  _initialiseState() {
    let state;

    if (this.state._fInitialised) {
      return;
    }
    let attrs = this._rsrc != null ? this._rsrc.get('data') : undefined;

    if (this._mode === 'new') {
      state = { _fInitialised: true };

      if (attrs != null) {
        attrs = attrs.delete('id');
        _.extend(state, attrs.toObject()); // shallow
      }
      _.extend(state, this.props.fnInitState(state));
      return this.setState(state);
    }
    if (attrs != null) {
      state = { _fInitialised: true };
      _.extend(state, attrs.toObject()); // shallow
      _.extend(state, this.props.fnInitState(state));
      return this.setState(state);
    }
  },

  _processInvalidates() {
    if (this.props.collectionDataPath != null) {
      act.markAsStale(this.props.collectionDataPath);
    }
    return Array.from(this.props.invalidates).map(invalidate => act.markAsStale(invalidate));
  },

  checkPermission() {
    const modeActionMap = {
      view: 'read',
      edit: 'edit',
      new: 'create',
    };
    const entityLid = modelNameEntityLidMap[this.props.modelName];
    if (entityLid) {
      const action = modeActionMap[this._mode];

      if (!App.cxStore.checkPermission(entityLid, action)) {
        this._ACTION = action;
        this._NOT_AUTHORIZED = this.props.t('This action is not allowed for this role for this entity.');
        return;
      }
    }
  },

  _getAttrsFromState() {
    let attrs = {};
    for (const attr in this.state) {
      let val = this.state[attr];
      if (['_fInitialised', '_fModalDelete', '_fModalSave'].includes(attr)) {
        continue;
      }
      // why???
      // continue if Immutable.Map.isMap val
      if (val === '') {
        val = null;
      } else if (_.isDate(val)) {
        val = val.toISOString();
      }
      attrs[attr] = val;
    }
    attrs = this.props.fnPrepareSave(attrs);
    delete attrs._fOriginForm;

    return attrs;
  },

  _changeMode(newMode) {
    const segments = this._route.path.split('/');
    if (this._mode === 'new' || this._mode === 'copy') {
      segments.pop();
      segments.push(this._rsrc.getIn(['data', 'id']));
      segments.push('view');
    } else {
      segments.pop();
      segments.pop();
      segments.push(this._rsrc.getIn(['data', 'id']));
      segments.push(newMode);
    }
    const newUrl = segments.join('/');

    this._mode = newMode;
    return this.props.navigate(newUrl);
  },

  _setSaveModalTitle(title) {
    return (this._saveModalTitle = title);
  },

  _setfDisableSaveConfirmation(val) {
    // lets the childs to allow confirmation only in some cases
    return (this._fDisableSaveConfirmation = val);
  },
  //#endregion

  //#region Renders
  _renderDoneButton() {
    return <Button label="Done" onClick={this._handleClickDone} />;
  },

  _renderNewButton() {
    if (this.props.entity) {
      if (!App.cxStore.checkPermission(this.props.entity, 'create')) {
        return;
      }
    }
    if (this.props.fNewButton === false) {
      return;
    }
    return <Button label="New" onClick={this._handleClickNew} />;
  },

  _renderCancelSaveButtons() {
    const fDisabled = (this._rsrc != null ? this._rsrc.get('state') : undefined) === k.rsrcStates.SYNCING;
    return (
      <Mui.Grid container spacing={1} justifyContent="flex-end">
        <Mui.Grid item>
          <Button label="Save" disabled={fDisabled || !this._fSaveAllowed} onClick={this._handleClickSave} />
        </Mui.Grid>
        <Mui.Grid item>
          <Button variant="outlined" label="Cancel" disabled={fDisabled} onClick={this._handleClickCancel} />
        </Mui.Grid>
      </Mui.Grid>
    );
  },

  _renderEditButton() {
    if (this.props.entity) {
      if (!App.cxStore.checkPermission(this.props.entity, 'edit')) {
        return null;
      }
    }
    if (this.state.isAlive !== undefined && this.state.isAlive === false) {
      return null;
    }
    return (
      <Mui.Grid item>
        <Button color="primary" label="Edit" onClick={this._handleClickEdit} />
      </Mui.Grid>
    );
  },
  _renderCreatedAt() {
    let msg;
    let date = moment(this.state.aliveStart).format('LLLL');
    let { creatorId } = this.state;
    let creator = __guard__(this.props.data.getIn(['users', 'data']), x => x.find(o => o.get('creatorId') === creatorId));
    if (creator != null) {
      msg = `Created by ${helpers.getUserFullName(creator)} on ${date}`;
    } else {
      msg = `Created on ${date}`;
    }
    return <div style={_style.lastCreated}>{msg}</div>;
  },

  _renderSaveConfirmation() {
    return (
      <Modal
        withHeader
        title={this._saveModalTitle}
        open={this.state._fModalSave}
        labelOk="Accept"
        labelCancel="Cancel"
        fullWidth
        maxWidth="lg"
        withCloseIcon={false}
        onSubmit={this._handleConfirmSave}
        onClose={() => this.setState({ _fModalSave: false })}
      />
    );
  },

  _renderLastUpdated() {
    let msg;
    const date = moment(this.state.updatedAt).format('LLLL');
    const { updaterId } = this.state;
    const updater = __guard__(this.props.data.getIn(['users', 'data']), x => x.find(o => o.get('updaterId') === updaterId));
    if (updater != null) {
      msg = `Last updated by ${helpers.getUserFullName(updater)} on ${date}`;
    } else {
      msg = `Last updated on ${date}`;
    }
    return <div style={_style.lastUpdated}>{msg}</div>;
  },
  _renderError(reason) {
    return <Error403 rsrc={this._rsrc} action={this._ACTION} details={reason} />;
  },

  _renderMain(needs) {
    const { FormComponent } = this.props;

    return (
      <Mui.Grid
        container
        id="EditPage"
        key={this._mode}
        className={`Edit${_.capitalize(this.props.modelName)}`}
        style={_style.outer}
      >
        {this._renderEditPageTitle()}
        <Misc.NewPaperWithPadding>
          <FormComponent
            {...Object.assign({ ...this.props }, needs, {
              dataPath: this._dataPath,
              rsrc: this._rsrc,
              mode: this._mode,
              curValues: this.state,
              onChangeEvent: this._changeAttrEvent,
              onChangeValue: this._changeAttrValue,
              onChangeAttr: this._changeAttr,
              setfSaveAllowed: this._setfSaveAllowed,
              setSaveModalTitle: this._setSaveModalTitle,
              setfDisableSaveConfirmation: this._setfDisableSaveConfirmation,
            })}
          />
        </Misc.NewPaperWithPadding>
        <div className="block w-full">
          {this._renderButtons('bottom')}
          {this._renderCreatedAt()}
          {this._renderLastUpdated()}
          {this._renderDeleteConfirmation()}
          {this._renderSaveConfirmation()}
        </div>
      </Mui.Grid>
    );
  },

  _renderEditPageTitle() {
    let subtitle, title;
    if (this._rsrc != null ? this._rsrc.getIn(['data', 'editPageTitle']) : undefined) {
      title = this._rsrc.getIn(['data', 'editPageTitle']);
    }
    if (this._rsrc != null ? this._rsrc.getIn(['data', 'editPageSubtitle']) : undefined) {
      subtitle = this._rsrc.getIn(['data', 'editPageSubtitle']);
    }
    if (subtitle || title) {
      return (
        <Mui.Paper style={{ padding: '5px', marginBottom: '1px' }}>
          {title && <Misc.PaperSectionTitle>{title}</Misc.PaperSectionTitle>}
          {subtitle && <div>{subtitle}</div>}
        </Mui.Paper>
      );
    }
  },

  _renderButtons(location) {
    switch (this._mode) {
      case 'view':
        return (
          <Misc.FlexRow key={`${location}Buttons`} style={_style.buttonsArea}>
            {this._renderDoneButton()}
            {this._renderNewButton()}
            {this._renderEditButton()}
          </Misc.FlexRow>
        );
      case 'edit':
        return (
          <Misc.FlexRow key={`${location}Buttons`} style={_style.buttonsArea}>
            {this._renderDeleteButton()}
            <Misc.FlexRowFlexSpacer />
            {this._renderCancelSaveButtons()}
          </Misc.FlexRow>
        );
      case 'new':
      case 'copy':
        return (
          <Misc.FlexRow key={`${location}Buttons`} style={_style.buttonsArea}>
            <Misc.FlexRowFlexSpacer />
            {this._renderCancelSaveButtons()}
          </Misc.FlexRow>
        );
    }
  },

  _renderDeleteButton() {
    if (this.props.entity) {
      if (!App.cxStore.checkPermission(this.props.entity, 'decommission')) {
        return;
      }
    }
    const fDisabled = (this._rsrc != null ? this._rsrc.get('state') : undefined) === k.rsrcStates.SYNCING;
    if (this.props.fDeleteButton === false) {
      return;
    }
    return <Button label="Delete" disabled={fDisabled} onClick={this._handleClickDelete} secondary />;
  },

  _renderDeleteConfirmation() {
    return (
      <Modal
        withHeader
        title="You are about to delete this item — are you sure?"
        open={this.state._fModalDelete}
        onSubmit={this._handleConfirmDelete}
        labelOk="Delete"
        labelCancel="Cancel"
        fullWidth
        maxWidth="lg"
        withCloseIcon={false}
        onClose={() => this.setState({ _fModalDelete: false })}
      />
    );
  },
  //#endregion

  render() {
    let needs;
    if (
      (this._rsrc != null ? this._rsrc.get('state') : undefined) === k.rsrcStates.IDLE &&
      __guard__(this._rsrc != null ? this._rsrc.get('errors') : undefined, x => x.size) > 0
    ) {
      const errors = this._rsrc != null ? this._rsrc.get('errors') : undefined;
      if (/unauthorized/i.test(errors.get('_gral'))) {
        this._NOT_AUTHORIZED = this.props.t('This role has no permission to retrieve this resource.');
      }
    }
    if (this._NOT_AUTHORIZED) {
      return this._renderError(this._NOT_AUTHORIZED);
    }

    let fReadyToRender = this.state._fInitialised;
    if (fReadyToRender) {
      needs = {};
      for (const need of Array.from(this.props.needs)) {
        const rsrcData = this.props.data.getIn([need.dataPath, 'data']);
        if (!rsrcData) {
          fReadyToRender = false;
          break;
        }
        needs[need.dataPath] = rsrcData;
      }
    }
    if (!fReadyToRender) {
      return <Misc.Loading />;
    }

    return this._renderMain(needs);
  },
});

//#region Styles
var _style = {
  outer: {
    paddingTop: 10,
    marginBottom: 30,
    width: '100%',
    height: '90%',
  },
  fieldsArea(fTopButtons) {
    return {
      padding: '10px 10px 10px 10px',
      borderTop: fTopButtons ? `1px solid ${k.gui.colors.lighterGray}` : undefined,
      borderBottom: `1px solid ${k.gui.colors.lighterGray}`,
    };
  },
  buttonsArea: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
    paddingBottom: 10,
  },
  lastCreated: {
    paddingTop: 15,
    marginLeft: 8,
    color: k.gui.colors.mediumGray,
  },
  lastUpdated: {
    marginLeft: 8,
    color: k.gui.colors.mediumGray,
  },
};
//#endregion

export default withRouter(withTranslation()(EditPage));

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
